export type SubmissionWithCreatedAt = {
  createdAt?: string | null;
};

/**
 * Newest first, so a clipper with many submissions finds their latest
 * (usually still-pending) ones without scrolling past old approved/reproved
 * history. Entries with a missing/invalid createdAt sink to the bottom
 * instead of floating to the top, so a data gap never masquerades as "newest".
 */
export function sortSubmissionsNewestFirst<T extends SubmissionWithCreatedAt>(submissions: T[]): T[] {
  return [...submissions].sort((a, b) => {
    const timeA = a.createdAt ? new Date(a.createdAt).getTime() : NaN;
    const timeB = b.createdAt ? new Date(b.createdAt).getTime() : NaN;
    const validA = Number.isFinite(timeA);
    const validB = Number.isFinite(timeB);
    if (!validA && !validB) return 0;
    if (!validA) return 1;
    if (!validB) return -1;
    return timeB - timeA;
  });
}
